import { PROJECT_NAME } from 'src/constants';

export const LabelUltra = () => {
  return (
    <label className="nj-label-free nj-label-ultra" data-e2e="label-tier-ultra">
      {`${PROJECT_NAME} Ultra`}
    </label>
  );
};
